import React from 'react'
import { useEffect } from 'react'
import { chatDatabase } from '../../../../Api/Utils/chatUtils';
import { ref, onValue, } from "firebase/database";
import { useState } from 'react';

const MessageUserCard = ({isActive, userAvatar, userName, lastMessage, getChatRoomData, roomLink, currentChatroomData, userID}) => {
    const [status, setstatus] = useState(true);
    useEffect(() => {
        onValue(ref(chatDatabase, `Users/${userID}`), (snapshot) => {
            setstatus(!snapshot.val().status)
        })
    }, [userID]);
    
    return (
        <div className={isActive ? "window-sidebar active" : "window-sidebar"} onClick={() => getChatRoomData(roomLink, currentChatroomData)}>
            <div className="avater" style={{position: 'relative'}}>
                <img src={userAvatar ? userAvatar : "./img/avatar.png"} alt="customer" />
                <div className="status" style={status ? {width: "10px", height: '10px', borderRadius: '50%', backgroundColor: '#565656', position: 'absolute', right: '5px', bottom: '5px'} : {width: "10px", height: '10px', borderRadius: '50%', backgroundColor: 'green', position: 'absolute', right: '5px', bottom: '5px'}}></div>
            </div>
            <div className="customer-details">
                <h4>{userName && userName}</h4>
                {lastMessage &&
                <p>{lastMessage}</p>}
            </div>
        </div>
    )
}

export default MessageUserCard
